<template>
  <div class="filter-item-pro">
    <div class="filter-item-warp">
      <div class="filter-item-content flex items-center">
        <div
          v-if="!isFromRoma && !isFieldFlag"
          :class="filterItem.negated === 'Y' ? 'icon-un is_checked' : 'icon-un'"
          @click="changeNavGator"
        >
          非
        </div>
        <el-select
          ref="selectField"
          v-model="filterItem.structWid"
          v-if="!isFieldsGroup"
          :default-first-option="true"
          @change="fieldChange"
          :class="['w210', 'ml6', { 'err-select': errFields.includes(structWid) || globalFieldsMapItem.isDeleted }]"
          size="mini"
          filterable
          clearable
          :disabled="$attrs.disabled"
        >
          <el-option
            v-for="item in fieldListView"
            :key="item.value"
            :label="item._label || item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-cascader
          :ref="`filterCascader${$attrs.groupIndex}${$attrs.filterItemIndex}`"
          v-model="filterItem.structWid"
          v-else
          @change="(val) => onDimChange(`filterCascader${$attrs.groupIndex}${$attrs.filterItemIndex}`, val)"
          :props="{ emitPath: !!$attrs.emitPath, checkStrictly: $attrs.checkStrictly }"
          :class="[
            `filterCascader${$attrs.groupIndex}${$attrs.filterItemIndex}`,
            'w210',
            'ml6',
            { 'err-select': judgeDelete() },
          ]"
          :popper-class="$attrs.customName"
          size="mini"
          :options="fieldListView"
          :show-all-levels="showAllLevel"
          :filter-method="filterNode"
          filterable
          clearable
          @visible-change="changeFieldVisible($event, `filterCascader${$attrs.groupIndex}${$attrs.filterItemIndex}`)"
          :separator="separatorSymbol"
          :disabled="$attrs.disabled"
        >
          <template slot-scope="{ node, data }">
            <span :title="data.fieldPhyName || data.label">{{ data.fieldPhyName || data.label }}</span>
          </template>
        </el-cascader>
        <el-select
          v-model="filterItem.compareType"
          class="ml6"
          style="width: 150px;"
          @change="conditionsChange"
          size="mini"
          :disabled="$attrs.disabled"
        >
          <el-option v-for="item in conditions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <filter-input-value
          v-if="showFilterInput"
          :fieldType="fieldType"
          :conditionType="conditionType"
          :filterItem="filterItem"
          :fieldListView="fieldListView"
          :separatorSymbol="separatorSymbol"
          v-bind="$attrs"
        ></filter-input-value>
        <span class="ml6">时</span>
        <div class="filter-icon-box" v-if="!isFieldFlag && !$attrs.disabled">
          <i class="el-icon-circle-plus-outline" v-if="!isFromRoma" @click="groupChangeEl('add')"></i>
          <i class="el-icon-remove-outline" @click="groupChangeEl('delete')"></i>
        </div>
      </div>
      <!--      {{filterGroup.childConditions[$attrs.filterItemIndex + 1].operator}}-->
      <el-select
        v-model="filterGroup.childConditions[$attrs.filterItemIndex + 1].operator"
        v-if="showFilterItemOperator"
        class="relative"
        style="top: 12px; width: 60px;"
        size="mini"
        :disabled="$attrs.disabled"
      >
        <el-option v-for="item in connectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import fieldTypeIcon from './fieldTypeIcon.vue'
import { connectOptions, conditionList, filterItemData, romaConditionList } from '../enum.data.js'
import { htmlFilterText, wordsJoin, getUUID, processString } from '../utils'
import filterInputValue from './filterInputValue.vue'
import _, { groupBy } from 'lodash'

export default {
  name: 'filter-item-pro',
  components: { filterInputValue, fieldTypeIcon },
  inject: {
    fieldTypeMap: { default: 'fieldTypeMap' },
  },
  props: {
    filterGroup: {
      type: Object,
      default: () => {},
    },
    filterItem: {
      type: Object,
      default: () => {},
    },
    errFields: {
      type: Array,
      default: () => [],
    },
    showAllLevel: {
      type: Boolean,
      default: true,
    },
    isFieldFlag: {
      type: Boolean,
      default: true,
    },
    separatorSymbol: {
      type: String,
      default: '/',
    },
  },
  computed: {
    /****
     * @params fieldName 字段中文名
     * @params field 字段物理名
     * @params fieldId 字段id
     * @params fieldType 英文字段类型
     * @params fieldTypeCn 中文字段类型
     * **/
    structWid() {
      return Array.isArray(this.filterItem.structWid)
        ? this.filterItem.structWid[this.filterItem.structWid.length - 1]
        : this.filterItem.structWid
    },
    fieldList() {
      const formatField = (v) => {
        const formatted = {
          ...v,
          label: htmlFilterText(wordsJoin(htmlFilterText(v.fieldName), htmlFilterText(v.field))),
          value: v.fieldId,
        }
        // 如果有children，递归格式化children
        if (v.children && Array.isArray(v.children) && v.children.length > 0) {
          formatted.children = v.children.map(child => formatField(child))
        }
        return formatted
      }
      return this.$attrs.fields.map((v) => formatField(v))
    },
    fieldFlatList() {
      if (!this.isFieldsGroup) return this.fieldList
      const result = []
      const deep = (list) => {
        list.forEach((t) => {
          result.push(t)
          if (t.children?.length) {
            deep(t.children)
          }
        })
      }
      deep(this.fieldList)
      console.log('fieldList:', this.fieldList, result)
      return result
    },
    globalFieldsMapItem() {
      return this.$attrs.globalFieldsMap && this.filterItem.fieldWid
        ? this.$attrs.globalFieldsMap[this.filterItem.fieldWid] || {}
        : {}
    },
    attributeList() {
      return this.$attrs.attributeList?.map((v) => {
        return {
          ...v,
          label: htmlFilterText(wordsJoin(v.fieldName, v.field)),
          value: v.fieldId,
        }
      })
    },
    // 是否匹配罗马模式
    isFromRoma() {
      return this.$attrs.isFromRoma
    },
    // 左侧选入字段是否分组
    isFieldsGroup() {
      return !!this.$attrs.fieldGroupName
    },
    // 这里需要转换字段是多级还是平铺
    fieldListView() {
      const formatFieldWithChildren = (v) => {
        const formatted = {
          ...v,
          label: v._label ?? htmlFilterText(wordsJoin(v.fieldName, v.field)),
          value: v.fieldId,
        }
        // 如果有children，递归格式化children
        if (v.children && Array.isArray(v.children) && v.children.length > 0) {
          formatted.children = v.children.map(child => formatFieldWithChildren(child))
        }
        return formatted
      }
      const fieldGroupName = this.$attrs.fieldGroupName
      if (this.isFieldsGroup) {
        if (fieldGroupName === 'custom') {
          console.log('this.fieldList:', this.fieldList,this.$attrs)
          return this.fieldList
        }
        if (fieldGroupName === 'customAll') {
          return this.$attrs.fields
        }
        let out = groupBy(this.$attrs.fields, (n) => n[fieldGroupName])
        const fieldOptionsList = []
        for (let i in out) {
          const temp = out[i]
          // 字段分组字段为空，默认现在在第一层级
          if (!i || i === 'undefined') {
            let arr = temp.map((v) => formatFieldWithChildren(v))
            fieldOptionsList.push(...arr)
          } else {
            fieldOptionsList.push({
              label: temp[0]['fieldGroupName'] || temp[0][fieldGroupName],
              value: i,
              children: temp.map((v) => formatFieldWithChildren(v)),
            })
          }
        }
        return fieldOptionsList
      } else {
        return this.fieldList
      }
    },
    showFilterInput() {
      return !['IS NULL', 'IS NOT NULL'].includes(this.filterItem.compareType) && !!this.filterItem.compareType
    },
    showFilterItemOperator() {
      return (
        this.filterGroup.childConditions.length > 1 && this.$attrs.filterItemIndex !== this.filterGroup.childConditions.length - 1
      )
    },
    fieldType() {
      return this.getEqualStruct(this.fieldList)?.fieldType?.toLowerCase() || this.filterItem.leftFieldType?.toLowerCase()
    },
    selectLeftField() {
      return this.getEqualStruct(this.fieldFlatList) ?? {}
    },
    conditionType() {
      let type = ''
      let conditionTypeMap = {
        text: ['text', 'varchar', 'bytea', 'code', 'ml', 'string'],
        date: ['date', 'timestamp', 'datetime', 'time', 'ym'],
        number: ['number', 'decimal', 'bignumber', 'NUMERIC', 'n', 'm', 'integer'],
        boolean: ['boolean'],
        fk: ['fk'], // 引用字段, 注意加了之后不要忘记添加类型list
      }
      for (let i in conditionTypeMap) {
        if (conditionTypeMap[i].includes(this.fieldType)) {
          type = i
        }
      }
      return type
    },
    // 引用标准表字段类型的不过滤运算符
    isFk() {
      return this.conditionType === 'fk'
    },
    isShowAllCondition() {
      return this.$attrs.isShowAllCondition
    },
    conditions() {
      // return this.isFromRoma ? romaConditionList : conditionList.filter(v => v.includes.includes(this.conditionType))
      return this.isFromRoma || this.isFk || this.isShowAllCondition
        ? conditionList
        : conditionList.filter((v) => v.includes.includes(this.conditionType))
    },
  },
  data() {
    return {
      connectOptions,
      getUUID,
    }
  },
  mounted() {
    if (this.isFieldsGroup && this.$refs[`filterCascader${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`]) {
      this.$refs[`filterCascader${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`].inputValue = this.structWid
    }
  },
  watch: {
    'filterItem.structWid': {
      handler(val) {
        this.$nextTick(() => {
          const isDelete = this.$attrs.fields?.filter((f) => f.fieldId === val)?.length === 0
          const currentLabel = this.$refs.selectField?.selected.currentLabel
          if (isDelete && val && currentLabel === val && this.$refs.selectField) {
            // 处理已选字段被删除，回显展示
            this.$refs.selectField.selected.currentLabel = this.$refs.selectField.selectedLabel = htmlFilterText(
              wordsJoin(this.filterItem.fieldDisplayName, this.filterItem.letfFilterField)
            )
          }
          this.setLabel(`filterCascader${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`)
        })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getEqualStruct(list) {
      const firstItem = list[0]
      if (firstItem?.hasOwnProperty('compareId') && Array.isArray(this.filterItem.structWid)) {
        return list.find((v) => v.compareId === this.filterItem.structWid?.join('$'))
      }
      return list.find((v) => v.fieldId === this.structWid)
    },
    changeFieldVisible(visible, refName) {
      if (!visible) {
        let cascader = this.$refs[`filterCascader${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`]
        if (!cascader.presentText) {
          cascader.presentText = this.structWid
        }
        // this.setLabel(refName)
      }
    },
    judgeDelete() {
      return this.$attrs.isMarkErr && this.structWid && !this.getEqualStruct(this.fieldList)
    },
    // 去掉默认选中第一个，因为继续输入的过程中，思考时间不定
    // chooseFirstOption() {
    //   let e = new KeyboardEvent('keydown', { keyCode: 40, which: 40 })
    //   this.$nextTick(() => {
    //     let cascader = document.querySelector(`.filterCascader${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`)
    //     cascader.dispatchEvent(e)
    //   })
    // },
    conditionsChange() {
      this.filterItem.showRightField = ''
      this.filterItem.rightFilterField = ''
      // this.filterItem.rightTableAlias = ''
      // this.filterItem.letfTableAlias = ''
      this.$set(this.filterItem, 'between', ['', ''])
      this.filterItem.rightFilterValue.filterValue = ''
      this.filterItem.rightFilterValue.filterValueArr = []
    },
    groupChangeEl(command) {
      if (command === 'delete' && this.filterGroup.childConditions.length === 1) {
        return this.$parent.onDeleteGroup()
      }
      command === 'add'
        ? this.filterGroup.childConditions.splice(this.$attrs.filterItemIndex + 1, 0, JSON.parse(JSON.stringify(filterItemData)))
        : this.filterGroup.childConditions.splice(this.$attrs.filterItemIndex, 1)
    },
    changeNavGator() {
      if (this.$attrs.disabled) {
        return
      }
      this.filterItem.negated = this.filterItem.negated === 'N' ? 'Y' : 'N'
    },
    setLabel(refName) {
      if (this.$attrs.customName !== 'tpl-filter') {
        return
      }
      let label = ''
      const val = this.filterItem.structWid
      const getLabel = (list, level) => {
        list.forEach((t) => {
          if (t.value === val[level]) {
            if (level === val.length - 1) {
              label = t._fullPathLabel
            }
            if (!label && t.fieldInfos) {
              getLabel(t.fieldInfos, ++level)
            }
          }
        })
      }
      setTimeout(() => {
        console.log('this.selectLeftField:', this.selectLeftField)
        getLabel(this.fieldListView, 0)
        if (this.$refs[refName]) {
          this.$refs[refName].inputValue = this.$refs[refName].presentText = label?.includes('$$$')
            ? this.selectLeftField?.showName || processString(label, '$$$')
            : this.selectLeftField.fieldFormateValue
        }
      })
    },
    onDimChange(refName) {
      this.fieldChange()
      this.setLabel(refName)
    },
    fieldChange(val) {
      this.filterItem.compareType = ''
      this.$set(this.filterItem, 'between', ['', ''])
      this.filterItem.leftFieldType = this.selectLeftField?.fieldType
      this.filterItem.letfFilterField =
        this.selectLeftField?.dimName || this.selectLeftField?.fieldPath || this.selectLeftField?.field
      this.filterItem.letfTableAlias = this.selectLeftField?.tableName
      this.filterItem.fieldDisplayName = this.selectLeftField?.compareId || this.selectLeftField?.fieldName
      this.filterItem.metaTable = this.selectLeftField?.metaTable
      this.filterItem.fieldWid = this.selectLeftField?.fieldId
      this.filterItem.metaTableDisplayName = this.selectLeftField?.metaTableDisplayName
      this.filterItem.leftDataSourceId = this.selectLeftField?.dataSourceId
      this.filterItem.leftSchemaName = this.selectLeftField?.schemaName
      this.filterItem.leftTableAliasCustom = this.selectLeftField?.tableAlias
      this.filterItem.leftFieldWid = this.selectLeftField?.wid
      this.filterItem.isCustomCol = this.selectLeftField?.isCustomCol
      this.filterItem.fieldAlias = this.selectLeftField?.fieldAlias
      this.filterItem.isDimField = this.selectLeftField?.isDimField
      this.filterItem.dimTableWid = this.selectLeftField?.dimTableWid
      this.filterItem.dimFieldWid = this.selectLeftField?.dimFieldWid
  
    },
    filterNode(data, value) {
      if (!value) return true
      return data.label.toLowerCase().includes(value.toLowerCase())
    },
  },
}
</script>

<style scoped lang="less">
.filter-item-pro {
  .filter-item-warp {
    padding: 12px 12px 12px 12px;
    background-color: #f8f8f8;
  }

  .filter-icon-box {
    display: flex;
    align-items: center;
    margin-left: 50px;

    i {
      font-size: 23px;
      color: #999;
      cursor: pointer;
      margin-right: 8px;
    }
  }
}
</style>
